import { JobEndpoint } from "@shared/types";

export const JOB_TYPE_ENDPOINTS_MAPPING: {
  [key in JobEndpoint]?: string;
} = {
  getBotsGraphsDataJob: "get_bots_graphs_data/",
  getBotsDataJob: "get_bots_data/",
  getOpenTradesDataJob: "get_open_trades_data/",
  getPortfolioDataJob: "get_portfolio_data/",
  getAccountsMainCoinsAvailableAmountJob:
    "get_accounts_main_coins_available_amount/",
  getAccountsMainCoinsTotalAndAvailableAmountJob:
    "get_accounts_main_coins_available_amount/",
  exportTradesJob: "export_trades/",
  exportBacktestTradesJob: "export_backtest_trades/",
  exportSignalsJob: "export_signals/",
};

export const NO_JOB_ARG_JOB_TYPES: Set<JobEndpoint> = new Set([
  "exportTradesJob",
  "exportSignalsJob",
  "exportBacktestTradesJob",
]);
